export default "__VITE_ASSET__kCoxteeX__"